import {
  BackOrderOfferCreditSubscriptionType,
  BackOrderSubscriptionType,
  ClosetSubscriptionType,
} from 'types/api/backorder';

export const backOrderSubscriptionName = {
  [ClosetSubscriptionType.PREMIUM_TRIAL]: 'Premium Trial',
  [ClosetSubscriptionType.STANDARD_TRIAL]: 'Standard Trial',
  [ClosetSubscriptionType.PREMIUM_INVOICE_PAYMENT]: 'Premium INV',
  [ClosetSubscriptionType.STANDARD_INVOICE_PAYMENT]: 'Standard INV',
  [ClosetSubscriptionType.ACADEMIC]: 'Academic',
};

export const backOrderSubscriptionItems: BackOrderSubscriptionType[] = [
  ClosetSubscriptionType.PREMIUM_TRIAL,
  ClosetSubscriptionType.STANDARD_TRIAL,
  ClosetSubscriptionType.PREMIUM_INVOICE_PAYMENT,
  ClosetSubscriptionType.STANDARD_INVOICE_PAYMENT,
  ClosetSubscriptionType.ACADEMIC,
];

export const backOrderSubscriptionPrice: {
  [key in BackOrderOfferCreditSubscriptionType]: 40 | 20;
} = {
  [ClosetSubscriptionType.PREMIUM_INVOICE_PAYMENT]: 40,
  [ClosetSubscriptionType.STANDARD_INVOICE_PAYMENT]: 20,
};
